// extracted by mini-css-extract-plugin
export var active = "_hv-7";
export var blink = "_hv-8";
export var dropDownSelector = "_hv-4";
export var dropDownWrapper = "_hv-3";
export var fakeCursor = "_hv-6";
export var fontSizeButton = "_hv-9";
export var formQuillEditor = "_hv-0";
export var pressed = "_hv-a";
export var qlBlank = "_hv-1";
export var textFormattingToolbar = "_hv-2";
export var textToolbarOption = "_hv-5";